import { render } from "./PostContextMenu.vue?vue&type=template&id=436373eb&scoped=true"
import script from "./PostContextMenu.vue?vue&type=script&lang=js"
export * from "./PostContextMenu.vue?vue&type=script&lang=js"

import "./PostContextMenu.vue?vue&type=style&index=0&id=436373eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436373eb"]])

export default __exports__